__webpack_require__.p = "/detectiveboard/";